import { createShortcut, Icon, Page, PageModuleNav, PageModuleNavItem } from '@app/ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

function useNav() {
  const { t } = useTranslation();

  return useMemo<PageModuleNav>(() => {
    const items: Array<PageModuleNavItem | false> = [
      {
        href: `/my-health/encounter`,
        icon: <Icon type="carry" />,
        label: t('encounters.list.title'),
        shortcut: createShortcut('shift+e'),
      },
      {
        href: `/my-health/document`,
        icon: <Icon type="paperclip" />,
        label: t('patients.documents.title'),
        shortcut: createShortcut('shift+d'),
      },
    ];

    return {
      defaultExpanded: 'my-health',
      expandedWidth: 250,
      items: items.filter((x) => !!x) as PageModuleNavItem[],
    };
  }, [t]);
}

export function PatientHealthPageModule() {
  const nav = useNav();

  return (
    <Page.Module nav={nav}>
      <Outlet />
    </Page.Module>
  );
}
